































































import Vue from 'vue';

import ArrowIcon from '@/components/Icons/Arrow.vue';

export default Vue.extend({
  name: 'QCard',
  components: {
    ArrowIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    goToPage(newPage: string) {
      (this as any).$emit('QCardClick', newPage);
    },
  },
  computed: {},
});
